export default "__VITE_PUBLIC_ASSET__c98db382__"